import React from "react";
import {Box, Popover, Typography} from "@mui/material";
import TransparentButton from "../TransparentButton/TransparentButton";
import {useTheme} from "../../../contexts/theme";
import { PopoverOrigin } from '@mui/material';

interface WarningPopoverProps {
    onClose: () => void;
    anchorEl: HTMLElement | null;
    anchorOrigin: PopoverOrigin;
    transformOrigin: PopoverOrigin;
    message: string;
    buttonText: string;
    onConfirm?: () => void;
}

const WarningPopover: React.FC<WarningPopoverProps> = ({ onConfirm = () => {}, anchorEl, onClose, anchorOrigin, transformOrigin, message, buttonText }) => {
    const theme = useTheme();

    function onConfirmationClick(){
        onConfirm();
        onClose();
    }

    return (<Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        slotProps={{
            paper: {
                sx: {
                    p: 2,
                    position: 'relative',
                    bgcolor: theme.palette.blue,
                    borderRadius: theme.border.radius.md,
                    boxShadow: 4,
                    borderStyle: theme.border.type.solid,
                    borderColor: theme.palette.white,
                    borderWidth: theme.border.width.medium,
                    mt: -1.5,
                    maxWidth: '500px'
                },
            },
        }}
    >
        <Typography variant="body1" sx={{ mb: 1, color: theme.palette.white }} >{message}</Typography>
        <Box width={'100%'} display={'flex'} justifyContent={'center'}>
            <TransparentButton text={buttonText} onClick={onConfirmationClick}></TransparentButton>
        </Box>

    </Popover>)
}

export default WarningPopover